import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import styles from "./EligibilityTrackerHistoricalClientPage.scss";
import ClinicBase from "components/layout/ClinicBase";
import { getClinicInfo } from "utils/ClinicData";
import { getHistoricalPatients } from "actions/ClinicActions";
import PatientCard from "components/eligibilityTracker/PatientCard";
import Button from "components/common/Button";
import SpinnerTakeover from "components/common/SpinnerTakeover";

function EligibilityTrackerHistoricalClientPage(props) {
  const { clientId, clinicId, loadPatients, patients, clientName, patientsLoading } = props;
  const history = useHistory();

  useEffect(() => {
    if(clientId && clinicId) {
      loadPatients(clinicId, clientId);
    }
  }, [clinicId, clientId, loadPatients]);

  return (
    <ClinicBase
      clinicId={clinicId}
      docTitle="Eligibility Tracker Client History"
      pageTitle="Eligibility Tracker - Client History"
    >
        <div className="flex flex-column full-width">
        <Button className={styles.backButton} icon onClick={() => history.push(`/admin/clinic/${clinicId}/programs/eligibility-tracker`)}>
            <i className="fa fa-arrow-left fa-fw" /> Search
        </Button>
      <div className={styles.root}>
        <p as="h2" className={styles.subheader}>Select Pet for {clientName}</p>
        <p className={styles.copy}>Choose a pet to view their eligibility history</p>
        <div className={styles.cards}>
            {patients && patients.length > 0 ? patients.map(patient => (
            <PatientCard
                key={patient.patientId}
                patientName={patient.patientName}
                patientUrl={`/admin/clinic/${clinicId}/programs/eligibility-tracker/history/${clientId}/patient-history/${patient.patientId}`}
                totalNumberInvoices={patient.totalNumberInvoices}
            />
            )) : (
                <p>No patients found.</p>
            )}
        </div>
        </div>
      </div>
      <SpinnerTakeover show={patientsLoading} onTop />
    </ClinicBase>
  );
}

export default connect((state, ownProps) => {
  const adminClinicId = Number(ownProps.match.params.clinicId);
  const clinic = getClinicInfo(state, adminClinicId);
  const clinicId = clinic ? clinic.clinicId : undefined;
  
  return {
    clinicId,
    clientId: ownProps.match.params.clientId || null,
    clientName: state.entities.historicalPatients.data.clientName,
    patients: state.entities.historicalPatients.data.historicalPatientInfo || [],
    patientsLoading: state.entities.historicalPatients.isLoading
  };
}, (dispatch) => ({
        loadPatients: (clinicId, clientId) => dispatch(getHistoricalPatients(clinicId, clientId)),
    })
)(EligibilityTrackerHistoricalClientPage);
